const key = 'tc.referral.attribution'
let memoryProof
export function saveReferralProof (proof) {
  if (typeof proof !== 'string' || !/^[A-Za-z0-9_-]+\.[a-f0-9]{64}$/.test(proof)) return
  memoryProof = proof
  try { window.localStorage.setItem(key, proof) } catch (_) {}
}
export function readReferralProof () {
  try { return window.localStorage.getItem(key) || memoryProof } catch (_) { return memoryProof }
}

// Public-site invitations hand the signed introduction to signup via a fragment.
// Capture it before the router or acquisition tracking rewrites the address.
if (typeof window !== 'undefined' && /^\/sign-up\/?$/.test(window.location.pathname)) {
  const fragment = new URLSearchParams(window.location.hash.slice(1))
  const proof = fragment.get('referralProof')
  if (proof) {
    saveReferralProof(proof)
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
  }
}
